import { render, staticRenderFns } from "./DetailRecrHRC.vue?vue&type=template&id=0685ce64&"
import script from "./DetailRecrHRC.vue?vue&type=script&lang=js&"
export * from "./DetailRecrHRC.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecrHRC.vue?vue&type=style&index=0&id=0685ce64&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0685ce64')) {
      api.createRecord('0685ce64', component.options)
    } else {
      api.reload('0685ce64', component.options)
    }
    module.hot.accept("./DetailRecrHRC.vue?vue&type=template&id=0685ce64&", function () {
      api.rerender('0685ce64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailRecrHRC.vue"
export default component.exports